export default __webpack_public_path__ + "static/media/sign_up_bottom.734e74fb.png";